import Vue from 'vue';
import tooltip from "@iflat-ui/directives/tooltip";

Vue.directive('tooltip', tooltip)
